module.exports = __webpack_public_path__ + "static/img/build.24fe586.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/build.png
// module id = YRKp
// module chunks = 1